module.exports = __webpack_public_path__ + "img/copy2.d4e5b1af.svg";